"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCheckboxState = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
var useCheckboxState = function useCheckboxState(isDefaultChecked, isChecked, onChange) {
  var _useControlledState = (0, _reactUseControlledState["default"])(isDefaultChecked, isChecked, onChange),
    _useControlledState2 = (0, _slicedToArray2["default"])(_useControlledState, 2),
    isStateChecked = _useControlledState2[0],
    setIsStateChecked = _useControlledState2[1];
  var handleChange = function handleChange(e) {
    setIsStateChecked(e.currentTarget.checked);
  };
  var handleClick = function handleClick(e) {
    e.stopPropagation();
  };
  return {
    isChecked: isStateChecked,
    onChange: handleChange,
    onClick: handleClick
  };
};
exports.useCheckboxState = useCheckboxState;